export function getdata() {
	var obj = {
		searchlist: [{
				prop: "cellCode",
				label: '项目代码',
				type: "input",
			},
			{
				prop: "cellName",
				label: '项目名称',
				type: "input",
			},
			{
				prop: "enableFlag",
				label: '是否启用',
				type: "select",
				selectval: [{
						label: "禁用",
						value: "0"
					},
					{
						label: "启用",
						value: "1"
					},
				],
			},
			{
				prop: "description",
				label: '说明',
				type: "input"
			}
		],
		searchdata: {
			cellCode: "",
			cellName: "",
			reportId: "",
			enableFlag: "",
			description: "",
			ids: "",
		},
		headData: [{
				title: "项目代码",
				prop: "cellCode",
				width: 160,
				issort: true,
			},
			{
				title: "项目名称",
				prop: "cellName",
				width: 160,
				issort: true,
			},
			{
				title: "报表名称",
				prop: "reportName",
				width: 160,
				custom: true
			},
			{
				title: "是否启用",
				prop: "enableFlag",
				width: "110",
				issort: true,
				custom: true
			},
			{
				title: "说明",
				prop: "description",
				width: 160,
				issort: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: 120,
				custom: true,
				fixed: 'right'
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		formlist:[
			{
				prop: 'cellCode',
                label: '项目代码',
                type: 'input',
                width: '340px'
            },{
				prop: 'cellName',
                label: '项目名称',
                type: 'input',
                width: '340px'
			},{
				prop: 'description',
                label: '说明',
                type: 'input',
                width: '340px'
			}
		],
		formdata: {
            cellCode: '',
            cellName: '',
            enableFlag: true,
			description: ''
        },
	}
	return obj
}
